module.exports = __webpack_public_path__ + "img/Public Cloud.7be1cf3.svg";